/*
 * @description：静态数据 统一维护
 */

export const dataToObj = (array: any[] = []) => {
  const obj = {};
  array.map((k) => {
    obj[k.value] = k.label;
    return k;
  });
  return obj;
};

export const createArray = (length: number, unit: string) => {
  return Array.from({ length }, (x, v) => ({
    label: `${v + 1}${unit}`,
    value: `${v + 1}`,
  }));
};

export enum ORDER_BIZ_TYPE {
  /** 服务商品订单 */
  SERVPACK = 'SERVPACK',
}

export type ORDER_STATUS_KEY =
  | 'all'
  | 'init'
  | 'failed'
  | 'reviewing'
  | 'review_failed'
  | 'delivery_wait'
  | 'delivered'
  | 'finished'
  | 'refund_success'
  | 'refund_inprocess'
  | 'in_payment'
  | 'refund_fail'
  | 'timeout'
  | 'closed'
  | 'expire_cancel'
  | 99;

/** ********** 订单状态 *********** */
export const ORDER_STATUS: { value: ORDER_STATUS_KEY; label: string }[] = [
  { value: 'all', label: '全部' },
  { value: 'init', label: '待支付' },
  { value: 'failed', label: '支付失败' },
  { value: 'reviewing', label: '待审核' },
  { value: 'review_failed', label: '审核失败' },
  { value: 'delivery_wait', label: '待发货' },
  { value: 'delivered', label: '待收货' },
  { value: 'finished', label: '已完成' },
  { value: 'refund_success', label: '已退款' },
  { value: 'refund_inprocess', label: '退款进行中' },
  { value: 'in_payment', label: '支付中' },
  { value: 'refund_fail', label: '退款失败' },
  { value: 'timeout', label: '订单超时' },
  { value: 'closed', label: '已取消' },
  { value: 'expire_cancel', label: '到期取消' },

  { value: 99, label: '已取消' },
];

/** ********** 退款状态 *********** */
export const REFUND_STATUS = [
  { value: 1, label: '退款中' },
  { value: 2, label: '已退款' },
  { value: 3, label: '退款失败' },
  { value: 4, label: '退款申请失败' },
  { value: 4, label: '退款申请失败' },
];

export const ORDER_STATUS_OBJ = dataToObj(ORDER_STATUS);

export const REFUND_STATUS_OBJ = dataToObj(REFUND_STATUS);

/** ********** 上拉加载的状态枚举 *********** */
export const LOAD_STATE = {
  normal: 0, // 普通
  abort: 1, // 中止
  loading: 2, // 加载中
  success: 3, // 加载成功
  failure: 4, // 加载失败
  complete: 5, // 加载完成（无新数据）
};

/** ********** 下拉刷新的状态枚举 *********** */
export const REFRESH_STATE = {
  normal: 0, // 普通
  pull: 1, // 下拉刷新（未满足刷新条件）
  drop: 2, // 释放立即刷新（满足刷新条件）
  loading: 3, // 加载中
  success: 4, // 加载成功
  failure: 5, // 加载失败
};

interface thirdPlatformOption {
  [key: string]: string;
}

/* 第三方对接的来源标识 统一管理 */
export const THIRD_PLATFORM_RESOURCECODE: thirdPlatformOption = {
  ZAHY: 'ZA', // 众安互医
  MBJK: 'MB', // 妙保 健康
  LHYW: 'UMP', // UMP联合医务
  SYY_DRUGSTROE: 'SYY', // 上药云药房
  SYY_MB: 'SYYMB', // 上药云药房 - 慢病
  SYY_XB: 'SYYXB', // 上药云药房 - 小病0元治
  GJSC: 'GJ', // 高济商城
  XLZY: 'XL', // 小鹿中医
  SSPS_PET: 'HCB', // 山水鹏狮 荟宠宝
  YDL_MENTALRELEASE: 'YDL', // 壹点灵 心理倾诉
  GLZ_VACCINE: 'GLZ', // 橄榄枝健康疫苗
  WEIYI_SERVICE: 'WEIYI', // 微医预约挂号服务
  UNION_DRUG: 'UNION_DRUG', // 药联
  KYUSHU_POP: 'POP', // 九州通
};

/**
 * @description 是否包含隐藏商品
 * - N 不展示隐藏商品
 */
export enum INCLUDE_HIDDEN {
  Y = 'YES',
  N = 'NO',
}

/** 互医微信小程序appid */
export const hospitalAppId = 'wx3c564538ea8e3905';

/** 众安好药师小程序 appid */
export const zadrugstoreAppId = 'wx701ef936afa75086';

/** 方伞健康小程序 appid */
export const zaFsHealthAppId = 'wx279e0bb82472bacd';

/** 方伞健康公众号 appid */
export const zafshealthGhAppId = 'wx7ba451739686a476';

// 好药师小程序 webview 标识
export const zaHysSource = 'ZA_HYS';

// 方伞健康小程序 webview 标识
export const zaFsjkSource = 'ZA_FSJK';

/** 互医微信小程序 webview 标识 */
export const hospitalWxMiniSource = 'ZA_HOSPITAL'; // 来自 qs 中的 source
export const hospitalWxMiniAppCode = 'hy';  // 来自 qs 中的 appCode

/** 直营小程序 webview 标识 */
export const dmXcxSource = 'ZABXMiniApp';

// 标识 key
export const SOURCE_KEY = '@@/source_key';

/**
 * @description 支付宝小程序第三方标识
 * - ZA_ASCLEPIUS_ALIPAY 众安医管家
 * - ZA_FSJK 方伞健康
 */
export enum AliAppletPartnerCode {
  ZA_ASCLEPIUS_ALIPAY = 'ZA_ASCLEPIUS_ALIPAY',
  ZA_FSJK = 'ZA_FSJK',
}

/**
 * @description 支付宝小程序第三方标识与预支付类型的映射关系
 */
export const PrePayAliPaySourceMap = {
  [AliAppletPartnerCode.ZA_ASCLEPIUS_ALIPAY]: 'HY',
  [AliAppletPartnerCode.ZA_FSJK]: 'FS',
};

/** 客服链接 */
export const customerServiceUrl = 'https://im2.zhongan.io/zaim/?accessId=1664521437687&tenantID=1663758569000237&color=blue';

/** 方伞客服链接 - 权益分组 */
export const fsGroupCSUrl = 'https://webchat-sh.clink.cn/chat.html?accessId=1bf84dd2-d17a-404f-ac96-0ccd3e59387d&language=zh_CN';
/** 方伞客服链接 - 众安医管家支付宝小程序 - 权益分组 */
export const fsHyAlipayGroupCSUrl = 'https://webchat-sh.clink.cn/chat.html?accessId=3edcf858-339f-4580-88ae-232138057b01&language=zh_CN';
/** 方伞客服链接 - 订单详情页 */
export const fsOrderCSUrl = 'https://webchat-sh.clink.cn/chat.html?accessId=044d8c37-bdd0-4caa-abbc-575e6bb8792e&language=zh_CN';
/** 方伞客服链接 - 众安医管家支付宝小程序 - 订单详情页 */
export const fsHyAlipayOrderCSUrl = 'https://webchat-sh.clink.cn/chat.html?accessId=0d7b3699-1f00-424d-b753-b1888ab7e54f&language=zh_CN';
/** 方伞客服链接 - 我的 */
export const fsMineCSUrl = 'https://webchat-sh.clink.cn/chat.html?accessId=8ece10a1-b214-4170-af90-137b03388b15&language=zh_CN';

/** 统一登录 - 众安开平 clientId */
export const zaOpenClientId = 'OPEN_SERVICE';

/** 统一登录 - 加密手机号方式 clientId */
export const aesCommonClientId = 'AES_COMMON';
